import { render } from "./ConfermaCodiceDueFattori.vue?vue&type=template&id=0514fae8&scoped=true"
import script from "./ConfermaCodiceDueFattori.vue?vue&type=script&lang=js"
export * from "./ConfermaCodiceDueFattori.vue?vue&type=script&lang=js"

import "./ConfermaCodiceDueFattori.vue?vue&type=style&index=0&id=0514fae8&scoped=true&lang=scss"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0514fae8"]])

export default __exports__